import PropTypes from 'prop-types';
import React from 'react';
import iconSrc from '../../utils/iconSrc';
import { CalloutWrapper, CalloutHeading, IconHolder, Message } from './styles';

const iconMap = {
  warning: 'alert-warning',
};

export const AlertCallout = ({
  type = 'warning',
  heading,
  headingLevel = 3,
  content,
}) => {
  const headingTag = `h${headingLevel}`;

  return (
    <CalloutWrapper $type={type}>
      <IconHolder src={iconSrc(iconMap[type])} $size="regular" />
      <div>
        <CalloutHeading as={headingTag}>{heading}</CalloutHeading>
        <Message richText={content} />
      </div>
    </CalloutWrapper>
  );
};

AlertCallout.propTypes = {
  type: PropTypes.oneOf(['warning']),
  heading: PropTypes.string,
  headingLevel: PropTypes.number,
  content: PropTypes.object,
};

export const AlertCalloutAssembly = ({ contentfulData }) => (
  <AlertCallout
    heading={contentfulData.title}
    headingLevel={contentfulData.headingLevel}
    content={contentfulData.content}
  />
);

AlertCalloutAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
